var map = {
	"./Badge.vue": "119f",
	"./Button.vue": "9ae8",
	"./Dropdown.vue": "e981",
	"./FormButtons.vue": "5ec1",
	"./FormElement.vue": "36fb",
	"./Header.vue": "d1de",
	"./Info.vue": "9630",
	"./Input.vue": "974b",
	"./LanguageSelect.vue": "b39d",
	"./LanguageSwitch.vue": "b8c9",
	"./Loader.vue": "0181",
	"./Loading.vue": "4f6c",
	"./Pagination.vue": "5adb",
	"./Section.vue": "e761",
	"./Switch.vue": "49a0",
	"./w-card.vue": "4b41",
	"./w-card/Card.vue": "0e9a",
	"./w-card/CardSection.vue": "295d",
	"./w-form/FormField.vue": "71eb",
	"./w-form/index.vue": "8d19",
	"./w-icon.vue": "0da8",
	"./w-image.vue": "c9af",
	"./w-modal.vue": "f97c",
	"./w-navbar/index.vue": "2eeb",
	"./w-navbar/item.vue": "465b",
	"./w-navbar/sub-item.vue": "b9a1",
	"./w-pagination.vue": "bfee",
	"./w-panel.vue": "1120",
	"./w-select.vue": "da70",
	"./w-spinner.vue": "b471",
	"./w-svg-icon.vue": "2d7e",
	"./w-switch.vue": "e721",
	"./w-tab/index.vue": "9d73",
	"./w-tab/w-tab-pane.vue": "452d",
	"./w-table/index.vue": "30f3",
	"./w-table/w-table-col.vue": "8426",
	"./w-tag.vue": "65cf",
	"./w-toast.vue": "9579",
	"./w-tooltip.vue": "1194"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1099";